(function () {
  var instances = new WeakMap();

  function rootsWithin(scope) {
    var container = scope || document;
    var roots = [];

    if (container.matches && container.matches('[data-nulela-ugc]')) roots.push(container);
    if (container.querySelectorAll) {
      container.querySelectorAll('[data-nulela-ugc]').forEach(function (root) {
        if (!roots.includes(root)) roots.push(root);
      });
    }

    return roots;
  }

  function initCarousel(root) {
    if (instances.has(root)) return;

    var track = root.querySelector('[data-nulela-ugc-track]');
    var cards = track ? track.querySelectorAll('[data-nulela-ugc-card]') : [];
    if (!track) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var delay = Math.max(3, Number(root.getAttribute('data-slide-speed') || 6)) * 1000;
    var interval = null;
    var pausedByFocus = false;
    var pausedByHover = false;
    var pausedByPointer = false;
    var removers = [];
    var visibleCards = new Set();
    var loadedVideos = new Set();
    var videoObserver = null;
    var rootObserver = null;
    var rootIsVisible = false;

    function listen(target, type, listener) {
      target.addEventListener(type, listener);
      removers.push(function () { target.removeEventListener(type, listener); });
    }

    function stop() {
      if (interval === null) return;
      window.clearInterval(interval);
      interval = null;
    }

    function cardTarget(card) {
      var trackRect = track.getBoundingClientRect();
      var cardRect = card.getBoundingClientRect();
      return track.scrollLeft + cardRect.left - trackRect.left;
    }

    function closestCardIndex() {
      var closestIndex = 0;
      var closestDistance = Infinity;

      cards.forEach(function (card, index) {
        var distance = Math.abs(cardTarget(card) - track.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function advance() {
      var nextIndex = (closestCardIndex() + 1) % cards.length;
      track.scrollTo({ left: cardTarget(cards[nextIndex]), behavior: 'smooth' });
    }

    function canStart() {
      return cards.length > 1 &&
        rootIsVisible &&
        document.visibilityState === 'visible' &&
        !reducedMotion.matches &&
        !pausedByFocus &&
        !pausedByHover &&
        !pausedByPointer;
    }

    function syncAutoplay() {
      stop();
      if (canStart()) interval = window.setInterval(advance, delay);
    }

    function enableVideoControls(video) {
      video.controls = true;
    }

    function videoFor(card) {
      return card.querySelector('video');
    }

    function pauseVideo(video) {
      if (video && typeof video.pause === 'function') video.pause();
    }

    function syncVideo(card) {
      var video = videoFor(card);
      if (!video) return;

      var canPlay = visibleCards.has(card)
        && document.visibilityState === 'visible'
        && !reducedMotion.matches;
      if (!canPlay) {
        pauseVideo(video);
        return;
      }

      if (!loadedVideos.has(video)) {
        video.preload = 'metadata';
        if (typeof video.load === 'function') video.load();
        loadedVideos.add(video);
      }
      if (typeof video.play === 'function') {
        var playResult = video.play();
        if (playResult && typeof playResult.catch === 'function') playResult.catch(function () {});
      }
    }

    function syncVideos() {
      cards.forEach(syncVideo);
    }

    function destroy() {
      stop();
      if (rootObserver) rootObserver.disconnect();
      if (videoObserver) videoObserver.disconnect();
      cards.forEach(function (card) { pauseVideo(videoFor(card)); });
      visibleCards.clear();
      loadedVideos.clear();
      while (removers.length) removers.pop()();
      root.removeAttribute('data-nulela-ugc-initialized');
      instances.delete(root);
    }

    root.setAttribute('data-nulela-ugc-initialized', 'true');
    instances.set(root, { destroy: destroy });

    cards.forEach(function (card) {
      var video = videoFor(card);
      if (!video) return;

      listen(video, 'pointerdown', function () {
        enableVideoControls(video);
      });
      listen(video, 'keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') enableVideoControls(video);
      });
    });

    if (typeof window.IntersectionObserver === 'function') {
      rootObserver = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== root) return;
          rootIsVisible = entry.isIntersecting && entry.intersectionRatio > 0;
          syncAutoplay();
        });
      }, { threshold: 0.1 });
      rootObserver.observe(root);

      videoObserver = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0) visibleCards.add(entry.target);
          else visibleCards.delete(entry.target);
          syncVideo(entry.target);
        });
      }, { threshold: 0.1 });
      cards.forEach(function (card) {
        if (videoFor(card)) videoObserver.observe(card);
      });
    }

    listen(root, 'mouseenter', function () {
      pausedByHover = true;
      syncAutoplay();
    });
    listen(root, 'mouseleave', function () {
      pausedByHover = false;
      syncAutoplay();
    });
    listen(root, 'focusin', function () {
      pausedByFocus = true;
      syncAutoplay();
    });
    listen(root, 'focusout', function (event) {
      if (root.contains(event.relatedTarget)) return;
      pausedByFocus = false;
      syncAutoplay();
    });
    listen(root, 'pointerdown', function () {
      pausedByPointer = true;
      syncAutoplay();
    });
    listen(window, 'pointerup', function () {
      if (!pausedByPointer) return;
      pausedByPointer = false;
      syncAutoplay();
    });
    listen(window, 'pointercancel', function () {
      if (!pausedByPointer) return;
      pausedByPointer = false;
      syncAutoplay();
    });
    listen(document, 'visibilitychange', function () {
      syncAutoplay();
      syncVideos();
    });
    listen(reducedMotion, 'change', function () {
      syncAutoplay();
      syncVideos();
    });
    syncAutoplay();
  }

  function initAll(scope) {
    rootsWithin(scope).forEach(initCarousel);
  }

  function destroyAll(scope) {
    rootsWithin(scope).forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroyAll(event.target); });
})();
